var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('v-card',{staticClass:"pt-5",attrs:{"elevation":"0"}},[_c('routes-table',{attrs:{"tableOptions":_vm.tableOptions},on:{"re-fetch-data":_vm.fetchData,"re-fetch-paginated-data":function($event){return _vm.fetchData($event)}}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }